import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { EventLocationViewModel } from "./location.model";

export class EventViewModel {
  public id: number;
  public momentStartDate: Moment; // Used for countdown component ans sorting
  public startDate: string;
  public startDayMonth: string;
  public startYear: string;
  public endDate: string;
  public endDayMonth:string;
  public endYear: string;
  public isExpired: boolean;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_de: string;
  public text_en: string;
  public get text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_en) ? this.text_de : this.text_en;
  }
  public image_photo: string;
  public locations: number[];
  public like: boolean;
}

export class EventDetailViewModel {
  public id: number;
  public momentStartDate: Moment; // Used for countdown component
  public startDate: string;
  public startTime: string;
  public endDate: string;
  public endTime: string;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_de: string;
  public text_en: string;
  public get text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_en) ? this.text_de : this.text_en;
  }
  public image_photo: string;
  public rate: number;
  public like: boolean;
  public locations: EventLocationViewModel[];
}

// Requests
export class EventSyncModel extends SyncModel {
}

// Responses
export class EventDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public release: boolean;
  public public: boolean;
  public date_ymd: number;
  public date_hms: number;
  public get has_date_hms(): boolean {
    return this.date_hms > -1;
  }
  public get date(): Moment {
    let hms = this.date_hms;
    if (hms === -1) {
      hms = 0; // start of the day
    }
    return Utils.GetMomentFromInt(this.date_ymd, hms);
  }
  public end_date_ymd: number;
  public end_date_hms: number;
  public get has_end_date_ymd(): boolean {
    return this.end_date_ymd > -1;
  }
  public get has_end_date_hms(): boolean {
    return this.end_date_hms > -1;
  }
  public get end_date(): Moment {
    let ymd = this.end_date_ymd;
    let hms = this.end_date_hms;
    if (ymd === -1) {
      ymd = this.date_ymd; // end is the start day
    }
    if (hms === -1) {
      hms = 235959; // end of the day
    }
    return Utils.GetMomentFromInt(ymd, hms);
  }
  public label_de: string;
  public label_en: string;
  public text_de: string;
  public text_en: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public locations: number[];
  public location: string;
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class EventSyncDataModel extends SyncDataModel {
  public events: EventDataModel[];
  public get models(): DataModel[] { return this.events; }
  public DeserializeType(): void {
    this._DeserializeType(EventDataModel);
  }
}
